import { FormikProps } from "formik";
import { useEffect } from "react";

import { Fields } from "./types";

export const useResetErrors = (
  formik: FormikProps<Fields>,
  firstAccess?: boolean,
) => {
  // ページ移動したときにバリデーションエラーがちらつかないようにする
  useEffect(() => {
    if (firstAccess) {
      formik.setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
